import React, { useState } from "react";
import "./styles.scss";
import Img from "Components/Img";
import { useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useWindowSize } from "Utilities";
import { useTranslation } from 'react-i18next';

function OrderSummary({ summaryData }) {
  const { cartDetails } = useSelector((state) => ({ cartDetails: state?.cartItems?.[0], isLoggedUser: state?.isLoggedUser}));
  const [width] = useWindowSize();
  const [details, setDetails] = useState(null);
  const [summaryDetails, setSummaryDetails] = useState(null);
  const cartImg = "res/img/carticon.svg";
  const { t } = useTranslation();
  
  const handleItemClick = (index) => {
    setDetails((prevIndex) => (prevIndex === index ? null : index));
  };

  const renderOptions = (options) =>
    options?.map((option, idx) => (
      <div key={idx} className="py-1 fs-14 flex line-6">
        <span>-</span>&nbsp;
        <div>
          <span>{option?.label}</span>:<span> {option?.value}</span>
        </div>
      </div>
    ));

  const renderDropbox = (dropbox) => {
    if (!dropbox?.length) return null;

    const aTagsArray = dropbox[0]?.split(",").map((tag) => tag.trim());

    return (
      <div className="py-1 fs-14 flex top">
        -&nbsp;<span className="text-nowrap">Bestand(en):</span>
        <div className="checkout_upload_image">
          {aTagsArray.map((element, index) => (
            <span
              key={index}
              className={`span__text ${element !== "1" ? "upload_file_mini_cart" : ""}`}
              dangerouslySetInnerHTML={{
                __html:
                  element === "1"
                    ? "<p>Ik lever het ontwerp later aan</p>"
                    : element,
              }}
            />
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="summary__section px-4">
      <div className="flex gap-4 py-6 heading">
        <div className="cartImg relative">
          <Img src={cartImg} />
        </div>
        <div className="flex middle">
          <p
            className="fw-700 fs-20 "
            onClick={() => setSummaryDetails(!summaryDetails)}
          >
          <span className="no-translate notranslate">{t("Besteloverzicht")}</span>
          </p>
          <div className="down__icon pointer" onClick={() => setSummaryDetails(!summaryDetails)}>
            {summaryDetails ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </div>
        </div>
      </div>

      {(width > 1024 || summaryDetails) && (
        <>
          <div className="product__section">
            {summaryData?.totals_detail?.items?.map((item, ind) => (
              <div key={ind} className="product__detail flex space-between w-1/1 py-4">
                <div className="product__title">
                  <h3 className="fw-700 fs-15 line-6">{item?.productName}</h3>
                  <div className="details__block flex col left">
                    {item?.additionalOptions?.length || item?.options?.length ? (
                      <div className="flex-1">
                        {cartDetails?.totals_detail?.isSample === 1 ? (
                          <div className="cart__details__options">
                            {renderOptions(item?.options?.filter(o => o.label === "Kleur"))}
                            {renderDropbox(item?.dropbox)}
                          </div>
                        ) : details === ind ? (
                          <div className="cart__details__options">
                            <div className="py-1 fs-14 flex line-6">
                              <span>-</span>&nbsp;
                              <div>
                                <span>{t("Artikelnummer")}</span>:<span> {item?.sku}</span>
                              </div>
                            </div>
                            {renderOptions(item?.options)}
                            {renderOptions(item?.additionalOptions)}
                            <div className="py-1 fs-14 flex line-6">
                              <span>-</span>&nbsp;
                              <div>
                                <span>Aantal</span>:<span> {item?.qty}</span>
                              </div>
                            </div>
                            {renderDropbox(item?.dropbox)}
                          </div>
                        ) : null}
                        {cartDetails?.totals_detail?.isSample !== 1 && (
                          <button
                            onClick={() => handleItemClick(ind)}
                            className="fs-14 text-underline pt-2"
                            aria-label="toggle details"
                          >
                            {details === ind ? "Verberg details" : "Bekijk details"}
                            <span className="flex middle up_icon">
                              {details === ind ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </span>
                          </button>
                        )}
                      </div>
                    ) : null}
                  </div>
                  {item?.deliveryDays?.text && (
                      <p className="fs-12 mt-2 text-grey" dangerouslySetInnerHTML={{ __html: item?.deliveryDays?.text }}/>
                    )}
                </div>
                <div className="product__price">
                  <h3 className="fw-700 fs-15 no-translate notranslate">{item?.totalPrice}</h3>
                </div>
              </div>
            ))}
          </div>

          <div className="priceDetails pt-6 pb-4">
            <table className="w-1/1">
              {cartDetails?.totals_detail?.isSample !== "1" && (
                <>
                  <tr>
                    <td className="no-translate notranslate">{t("Digitale drukproef")}</td>
                    <td><b className="normal green no-translate notranslate">{t("Gratis")}</b></td>
                  </tr>
                  <tr>
                    <td className="no-translate notranslate">{t("Instelkosten")}</td>
                    <td className="no-translate notranslate">
                      {summaryData?.totals_detail?.setupCost === "0,00"
                        ? <b className="normal green no-translate notranslate">{t("Gratis")}</b>
                        : summaryData?.totals_detail?.setupCost}
                    </td>
                  </tr>
                </>
              )}
              <tr>
                <td>{summaryData?.shippingTitle}</td>
                <td className={summaryData?.totals_detail?.postageCosts === "op nacalculatie *" ? "" : "no-translate notranslate"}>
                  {summaryData?.totals_detail?.postageCosts === "0,00"
                    ? <b className="normal green no-translate notranslate">{t("Gratis")}</b>
                    : summaryData?.totals_detail?.postageCosts || ""}
                </td>
              </tr>
              {cartDetails?.totals_detail?.productCost &&
                Object.values(cartDetails?.totals_detail?.productCost).map((item, idx) => (
                  <tr key={idx}>
                    <td>{item?.label}</td>
                    <td className="no-translate notranslate" >{item?.productCost}</td>
                  </tr>
                ))}

                 {cartDetails?.totals_detail?.custom_price?.length > 0 && (
          Object.entries(
            cartDetails.totals_detail.custom_price.reduce((acc, item) => {
              const label = item.label;
              const value = parseFloat(item.value);
              acc[label] = (acc[label] || 0) + value;
              return acc;
            }, {})
          ).map(([label, total], index) => (
            <tr key={`custom-price-${index}`}>
              <td>{label}</td>
              <td>{total.toFixed(2).replace('.', ',')}</td>
            </tr>
          ))
        )}
              {summaryData?.totals_detail?.couponCode && (
                <tr>
                  <td><span className="no-translate notranslate">{t("Kortingscode")}</span> ({summaryData?.totals_detail?.couponCode})</td>
                  <td className="no-translate notranslate">-{summaryData?.totals_detail?.discount_amount}</td>
                </tr>
              )}
              <tr className="fw-700 ">
                <td className="fs-20 no-translate notranslate">{t("Totaal (excl. BTW)")}</td>
                <td className="fs-26 no-translate notranslate">
                  {summaryData?.tax_details?.subtotal_original}
                </td>
              </tr>
               {/* <tr>
                <td><span className="no-translate notranslate">{t("BTW")}</span></td>
                <td className="no-translate notranslate">{summaryData?.tax_details?.tax_amount}</td>
              </tr> */}
               {
                  summaryData?.tax_details?.tax_breakdown &&
                  (
                    summaryData.tax_details.tax_breakdown.every(tax => tax.tax_amount === "0,00") ? (
                      <tr>
                        <td className="no-translate notranslate">{"BTW 0%"}</td>
                        <td className="no-translate notranslate">0,00</td>
                      </tr>
                    ) : (
                      summaryData.tax_details.tax_breakdown.map((tax, index) => (
                        <tr key={index}>
                          <td>{`${t("BTW")}${tax?.tax_amount === "0,00" ? ` (0%)` : ` ${tax?.tax_rate}% ${tax?.country_code}` }`}</td>
                          <td className="no-translate notranslate">{tax?.tax_amount}</td>
                        </tr>
                      ))
                    )
                  )
                }
              <tr>
                <td className="no-translate notranslate">{t("Totaalbedrag")}</td>
                <td className="no-translate notranslate">{summaryData?.tax_details?.grandTotal}</td>
              </tr>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

export default OrderSummary;
